export default function LogIf(log_level, message) {
  const logLevels = {
    fatal: 5,
    error: 4,
    warn: 3,
    info: 2,
    debug: 1,
  };
  const min_log_level = logLevels[process.env.LOG_LEVEL];
  if (logLevels[log_level] >= min_log_level) {
    console.log(message);
  }
}
